import { useForm, usePage, Link } from "@inertiajs/react";
import AuthLayout from "@/layout/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import GoogleSignInButton from "@/components/app/GoogleSignInButton";
import OrDivider from "@/components/app/OrDivider";

export default function SignIn() {
  const { routes } = usePage().props;
  const form = useForm({ email_address: "", password: "" });

  function submit(e) {
    e.preventDefault();
    form.post(routes.session_create);
  }

  return (
    <AuthLayout>
      <Card>
        <CardHeader>
          <CardTitle>Welcome back</CardTitle>
          <CardDescription>Sign in to your GameKnight account</CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <GoogleSignInButton action={routes.google_auth} />
          <OrDivider />

          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="email_address">Email</Label>
              <Input
                id="email_address"
                type="email"
                autoComplete="username"
                autoFocus
                placeholder="you@example.com"
                value={form.data.email_address}
                onChange={(e) => form.setData("email_address", e.target.value)}
              />
            </div>

            <div className="space-y-1.5">
              <div className="flex items-center justify-between">
                <Label htmlFor="password">Password</Label>
                <Link
                  href={routes.new_password}
                  className="text-xs text-muted-foreground hover:text-foreground transition-colors"
                >
                  Forgot password?
                </Link>
              </div>
              <Input
                id="password"
                type="password"
                autoComplete="current-password"
                placeholder="••••••••"
                value={form.data.password}
                onChange={(e) => form.setData("password", e.target.value)}
              />
            </div>

            <Button type="submit" className="w-full" disabled={form.processing}>
              {form.processing ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </CardContent>

        <CardFooter className="justify-center text-sm text-muted-foreground">
          No account?&nbsp;
          <Link href={routes.signup} className="text-primary hover:underline font-medium">
            Sign up
          </Link>
        </CardFooter>
      </Card>
    </AuthLayout>
  );
}

